import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-28 pb-16 px-4 bg-white text-center" data-id="element-177">
      <div className="max-w-4xl mx-auto" data-id="element-178">
        <div className="inline-block bg-brand-light text-brand-blue font-bold px-4 py-1 rounded-full mb-6 border border-brand-blue/20" data-id="element-179">
          🧪 QUÍMICA EN ACCIÓN
        </div>

        <h1 className="text-3xl md:text-5xl font-black text-brand-dark mb-2 leading-tight tracking-tight" data-id="element-180">
          Todo tu año de Química <br className="hidden md:block" data-id="element-181" />
          <span className="text-brand-blue underline decoration-brand-orange decoration-4 md:decoration-8 underline-offset-4 md:underline-offset-8" data-id="element-182">
            resuelto.
          </span>
        </h1>

        <a href="#compra" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 mb-8" data-id="element-183">
          <img src="https://cdn.magicpatterns.com/uploads/b9eeoqdPnXXuU46xT6YM7T/MEGA_PACK_BIOLOGIA_EN_ACCION_DE_1°_A_6°_ANO_(4).png" alt="MegaPack Química en Acción" className="w-full max-w-2xl mx-auto drop-shadow-2xl rounded-xl" data-id="element-184" />
        </a>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-185">
          QUÍMICA EN ACCIÓN — MegaPack Química en Acción — Combo Completo
        </h2>

        <p className="text-xl md:text-2xl italic text-gray-600 font-medium mb-8" data-id="element-186">
          "Listo para usar. Sin buscar más."
        </p>

        <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-187">
          El sistema que usan cientos de profesores de Química de secundaria en
          Argentina para planificar todo el año en una tarde — sin improvisar,
          sin buscar y sin perder domingos.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-188">
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-189">
            📄 100% PDF
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-190">
            ⚡ Acceso inmediato
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-191">
            🇦🇷 Currículo argentino
          </span>
        </div>

        <div className="max-w-2xl mx-auto mb-6" data-id="element-192">
          <CTAButton text="🧪 → QUIERO MI MEGAPACK AHORA" href="#compra" isLink={true} data-id="element-193" />
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm md:text-base text-gray-600 font-medium" data-id="element-194">
          <span className="flex items-center gap-1" data-id="element-195">
            <ShieldCheckIcon className="w-5 h-5 text-brand-green" data-id="element-196" /> Garantía 7
            días sin preguntas
          </span>
          <span className="flex items-center gap-1" data-id="element-197">
            <LockIcon className="w-5 h-5 text-gray-500" data-id="element-198" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-199">
            <CreditCardIcon className="w-5 h-5 text-blue-500" data-id="element-200" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}